import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'categoryFullName' })
export class CategoryFullNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(category): string {
        if (category) {
            const parentDataString = category.parentData.map((p) => p.label).join(' / ');
            return parentDataString ? parentDataString + ' / ' + category.label : category.label;
        }

        return this.translateService.instant('No category');
    }
}
